import React, { Component } from 'react';
import LineItemsTable from '../../components/LineItemsTable';
import classNames from 'classnames';
import LineItemDetail from '../LineItemDetail/index';
import TripTableHeader from 'Components/TripTableHeader/index';
import { scroll } from 'Utils/';
import { RFQ_PROV_DISPLAY_LIMIT } from 'Constants/commonConstants';

export default class RFQLineItems extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: true,
			overflowHidden: true,
			currentLineItem: {},
			openLineItem: false
		};

		this.toggle = this.toggle.bind(this);
		this.removeOverFlowHidden = this.removeOverFlowHidden.bind(this);
		this.setOverFlowHidden = this.setOverFlowHidden.bind(this);
		this.openLineItemOverlay = this.openLineItemOverlay.bind(this);
		this.hideLineItem = this.hideLineItem.bind(this);
	}

	openLineItemOverlay(lineItem) {
		this.setState({
			currentLineItem: lineItem,
			openLineItem: true
		}, () => {
			//scroll(this.LineItemDetailRef.offsetTop, 500);
		});
	}

	hideLineItem() {
		this.setState({ openLineItem: false }, () => {
			this.setOverFlowHidden();
		});
	}

	toggle() {
		this.setState({ isOpen: !this.state.isOpen }, () => {
			if (!this.state.isOpen) {
				this.hideLineItem();
			}
		});
	}

	removeOverFlowHidden() {
		this.setState({ overflowHidden: false });
	}

	setOverFlowHidden() {
		this.setState({ overflowHidden: true });
	}

	render() {
		const {
			lineItems,
			biddingStage,
			postBid,
			postBidAll,
			pricingBasis,
			paymentCycles,
			vehicleTypes,
			vehicleBodyTypes,
			tripBids,
			fetchBids,
			postChallengePrice,
			offset,
			tripsCount,
			loadingTrips,
			paymentBasis,
			systemTime,
			courierPostBid,
			otherCharges,
			rfq,
			courierMovements,
			courierModes,
			courierAcceptOrRejectLoiList,
			courierAcceptOrRejectCPList,
			slabList,
			isCourierTermAccepted,
			currencyDetails,
			additionalZoneList,
			fromZones,
			toZones,
			currencyTypes,
			tZones,
			plantNames,
			materials,
			distNames,
			vendorWithDrawBid,
			postDisposalBid,
			bidSubmitList,
			totalValueVisibilityOnProvider,
			getVehicleTypes,
			seaAndAirLines,
			bulkUpdateDataStore,
			totalValueVisibilityOfL1OnProvider,
			visibilityOfLotRankingForProvider,
			maxCountToWithdrawBid,
			showPRDetails,
			readyToPostBid,
			loiCeilingAccepted,
			vehicleTypesList,
			allowTransporterToAddCostHeadDuringBidding,
			getPlantWiseCostHeads,
			transporterBiddedCount
		} = this.props;
		const { openLineItem, currentLineItem } = this.state;
		return (
			<div className="box-shadow col-1 pl-30 pt-30 pr-30 pb-25 mt-30 border-light br-5 mb-50">
				<TripTableHeader
					secondaryContractType={this.props.rfq.rfqDetails.secondaryContractType}
					offset={offset}
					fetchTrips={this.props.getTrips}
					vehicleTypes={vehicleTypes}
					showPagination={tripsCount > RFQ_PROV_DISPLAY_LIMIT}
					vehicleBodyTypes={vehicleBodyTypes}
					viewMode={true}
					header={'Line Items'}
					searchPlaceholder={'Search Line Items'}
					countText={`${this.props.rfq.type === 9 ? 'Lanes' : 'Trips'} Found`}
					tripsCount={tripsCount}
					rfqType={this.props.rfq.type}
					includesOtherCharges={rfq.includesOtherCharges}
					acceptPartialSolution={rfq.rfqDetails.acceptPartialSolution}
					bidCompletedCount={rfq.rfqDetails.bidCompletedCount}
					bidPendingCount={rfq.rfqDetails.bidPendingCount}
					courierTatWeight={rfq.courierTatWeight}
					courierPriceWeight={rfq.courierPriceWeight}
					rfqDetails={rfq.rfqDetails}
					courierZones={this.props.courierZones}
					courierMovements={courierMovements}
					courierModes={courierModes}
					rfqServiceType={rfq.serviceType}
					slabList={slabList}
					fromZones={fromZones}
					toZones={toZones}
					tZones = {tZones}
					plantNames = {plantNames}
					materials = {materials}
					enabledObdsFilter = {rfq.enabledObdsFilter}
                    distNames = {distNames}
					companyId = {rfq.companyId}
					getVehicleTypes = {getVehicleTypes}
					biddingPercentageSolution={rfq.rfqDetails.biddingPercentageSolution}
				/>
				<div className="max-height-transition">
					<LineItemsTable
						rfq={this.props.rfq}
						lineItems={lineItems}
						biddingStage={biddingStage}
						removeOverFlowHidden={this.removeOverFlowHidden}
						setOverFlowHidden={this.setOverFlowHidden}
						postBid={postBid}
						postBidAll={postBidAll}
						pricingBasis={pricingBasis}
						paymentCycles={paymentCycles}
						openLineItemOverlay={this.openLineItemOverlay}
						openLineItem={openLineItem}
						tripBids={tripBids}
						fetchBids={fetchBids}
						postChallengePrice={postChallengePrice}
						acceptLoi={this.props.acceptLoi}
						rejectLoi={this.props.rejectLoi}
						loadingTrips={loadingTrips}
						paymentBasis={paymentBasis}
						hideLineItem={this.hideLineItem}
						currentLineItem={currentLineItem}
						acceptRejectCP={this.props.acceptRejectCP}
						systemTime={systemTime}
						updateHandlingCharges={this.props.updateHandlingCharges}
						otherCostAcceptRejectCP={this.props.otherCostAcceptRejectCP}
						courierZones={this.props.courierZones}
						courierPostBid={courierPostBid}
						otherCharges={otherCharges}
						courierAcceptOrRejectLoiList={courierAcceptOrRejectLoiList}
						setAcceptOrRejectLoiList={this.props.setAcceptOrRejectLoiList}
						courierAcceptOrRejectCPList={courierAcceptOrRejectCPList}
						isCourierTermAccepted={isCourierTermAccepted}
						currencyDetails={currencyDetails}
						additionalZoneList={additionalZoneList}
						currencyTypes={currencyTypes}
						vendorWithDrawBid = {vendorWithDrawBid}
						postDisposalBid={postDisposalBid}
						bidSubmitList={bidSubmitList}
						totalValueVisibilityOnProvider={totalValueVisibilityOnProvider}
						seaAndAirLines={seaAndAirLines}
						bulkUpdateDataStore={bulkUpdateDataStore}
						totalValueVisibilityOfL1OnProvider={totalValueVisibilityOfL1OnProvider}
						visibilityOfLotRankingForProvider={visibilityOfLotRankingForProvider}
						maxCountToWithdrawBid={maxCountToWithdrawBid}
						showPRDetails={showPRDetails}
						readyToPostBid={readyToPostBid}
						loiCeilingAccepted={loiCeilingAccepted}
						postCostHeadCP={this.props.postCostHeadCP}
						postCostHeadCounterPrice={this.props.postCostHeadCounterPrice}
						vehicleTypesList={vehicleTypesList}
						allowTransporterToAddCostHeadDuringBidding={allowTransporterToAddCostHeadDuringBidding}
						getPlantWiseCostHeads={getPlantWiseCostHeads}
						transporterBiddedCount={transporterBiddedCount}
					/>
				</div>

				{/* {
                    openLineItem && <div ref={(e)=> {this.LineItemDetailRef = e}}><LineItemDetail 
                    lineItem={currentLineItem}
                    key="lineItemDetail"
                    pricingBasis={pricingBasis}
                    paymentCycles={paymentCycles}
                    hideLineItem={this.hideLineItem}
                    openLineItem={openLineItem} /></div>
                } */}

			</div>
		)
	}
}
